import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const ProductTypesWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default ProductTypesWrapper